(function () {
  function bind() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    document.querySelectorAll('.header_cart_icon').forEach(function (link) {
      if (link.id === 'cart-icon-bubble') return;
      if (link.dataset.cartDrawerBound === 'true') return;
      link.dataset.cartDrawerBound = 'true';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        drawer.open(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
